import useCache from "../useCache";

export const useTableCacheForForm = (cacheKey, itemKey, editId) => {
    const [tableData] = useCache(cacheKey,null)
    console.log(tableData)
    const matchedItem = tableData?.find(item => item[itemKey] == editId);
    console.log(matchedItem,editId,itemKey)
    return matchedItem ?? {};
  }